<script>
import { BNavText } from "bootstrap-vue";

export default {
  extends: BNavText
};
</script>